var ENVOIRNMENT = {
    baseUrls: {
        baseAPIUrl: "https://apinrm-prod-austcentral-crf5a2gmc4chexd5.australiacentral-01.azurewebsites.net/api/",
        instrumentationKey: 'f914da3f-0811-4f25-8b2b-99a9c1c7f434',
        baseFileUrl: "https://nrmconnectwebprod.blob.core.windows.net/ngcouncil/",
    },
    MicrosforEntra: {
        signInUrl: "https://login.microsoftonline.com/5ea099bb-0209-4be9-8af2-eb30ecd1fe89/oauth2/v2.0/authorize?client_id=8fbcb49e-428d-4c32-adb3-a539a66adda7&nonce=defaultNonce&redirect_uri=https://connect.ngcouncil.org.au/auth&scope=openid&response_type=id_token&prompt=login&sso_reload=true",
    }
};
if (window.location.hostname === 'localhost') {
     ENVOIRNMENT.baseUrls.baseAPIUrl = "https://nrmapi.ngcouncil.org.au/api/";
    //ENVOIRNMENT.baseUrls.baseAPIUrl = "https://apinrm-prod-austcentral-crf5a2gmc4chexd5.australiacentral-01.azurewebsites.net/api/";
    ENVOIRNMENT.baseUrls.instrumentationKey = '9de126cc-7505-4017-b9e0-283e3988be51';
    ENVOIRNMENT.MicrosforEntra.signInUrl = "https://login.microsoftonline.com/5ea099bb-0209-4be9-8af2-eb30ecd1fe89/oauth2/v2.0/authorize?client_id=8fbcb49e-428d-4c32-adb3-a539a66adda7&nonce=defaultNonce&redirect_uri=http://localhost:4200/auth&scope=openid&response_type=id_token&prompt=login&sso_reload=true";
    ENVOIRNMENT.baseUrls.baseFileUrl = "https://nrmconnectwebprod.blob.core.windows.net/ngcouncil/";
} else {
    ENVOIRNMENT.baseUrls.baseAPIUrl = "https://nrmapi.ngcouncil.org.au/api/";
    ENVOIRNMENT.baseUrls.instrumentationKey = '9de126cc-7505-4017-b9e0-283e3988be51';
    ENVOIRNMENT.MicrosforEntra.signInUrl = "https://login.microsoftonline.com/5ea099bb-0209-4be9-8af2-eb30ecd1fe89/oauth2/v2.0/authorize?client_id=8fbcb49e-428d-4c32-adb3-a539a66adda7&nonce=defaultNonce&redirect_uri=https://connect.ngcouncil.org.au/auth&scope=openid&response_type=id_token&prompt=login&sso_reload=true";
    ENVOIRNMENT.baseUrls.baseFileUrl = "https://nrmconnectwebprod.blob.core.windows.net/ngcouncil/";
}


export { ENVOIRNMENT };
